import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../hooks/AuthProvider'; // Adjust path as needed
import { pdf } from '@react-pdf/renderer';
import { getStorage, ref, getBytes, getDownloadURL } from 'firebase/storage';
import IncidentReportPDF from '../PDF Functions/IncidentReportPDF';
import Compressor from 'compressorjs';
import '../TruckServices/ChecklistForm.css';

const IncidentEmailSender = ({ selectedReport, pdfBase64, onClose }) => {
  const [status, setStatus] = useState('Preparing email...');
  const [isSending, setIsSending] = useState(true);
  const [error, setError] = useState(null);
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();


  const compressImage = (file) =>
    new Promise((resolve, reject) => {
      new Compressor(file, {
        quality: 0.4,
        maxWidth: 1024,
        maxHeight: 1024,
        convertSize: 200000,
        success: resolve,
        error: reject,
      });
    });

  const getDashboardLink = () => {
      if (!currentUser || !currentUser.type) return '/';
      switch (currentUser.type.toLowerCase()) {
        case 'admin':
          return '/admin-dash';
        case 'manager':
          return '/manager-dashboard';
        case 'supervisor':
          return '/supervisor-dashboard';
        case 'spray_tech':
          return '/spray-tech-dashboard';
        default:
          return '/';
      }
    };

    const getManagerEmailsByMarket = (marketInput) => {
  if (!marketInput) return [];

  const normalized = marketInput.trim().toUpperCase(); // Normalize input

  const marketEmailMap = {
    SS1: ['bbreland@rotoloconsultants.com', 'cbillingsley@rotoloconsultants.com'],
    SS2: ['chammontree@rotoloconsultants.com', 'tlarriviere@rotoloconsultants.com'],
    SS3: ['ggoings@rotoloconsultants.com', 'dtoney@rotoloconsultants.com', 'cbillingsley@rotoloconsultants.com'],
    SS4: ['ogore@rotoloconsultants.com', 'jcollins@rotoloconsultants.com', 'cbillingsley@rotoloconsultants.com'],
    NS1: ['bwatson@rotoloconsultants.com', 'gking@rotoloconsultants.com', 'cbillingsley@rotoloconsultants.com'],
    NS2: ['bwatson@rotoloconsultants.com','ggonzalez@rotoloconsultants.com', 'cbillingsley@rotoloconsultants.com'],
    COA1: ['jhigdon@rotoloconsultants.com', 'aperez@rotoloconsultants.com', 'cbillingsley@rotoloconsultants.com'],
    FOL: ['mridgeway@rotoloconsultants.com', 'sknowles@rotoloconsultants.com', 'jhigdon@rotoloconsultants.com', 'cbillingsley@rotoloconsultants.com'],
    NS3: ['bwatson@rotoloconsultants.com', 'ggonzalez@rotoloconsultants.com', 'cbillingsley@rotoloconsultants.com'],
    COA2: ['jhigdon@rotoloconsultants.com', 'dwalker@rotoloconsultants.com', 'cbillingsley@rotoloconsultants.com'],
    SS5: ['jfox@rotoloconsultants.com', 'cbillingsley@rotoloconsultants.com'],
    LAF: ['wmacmurdo@rotoloconsultants.com', 'abreaux@rotoloconsultants.com', 'bbreaux@rotoloconsultants.com'],
    LKC: ['shymel@rotoloconsultants.com', 'jdelafosse@rotoloconsultants.com', 'wmacmurdo@rotoloconsultants.com'],
    BR1: ['cmurphey@rotoloconsultants.com', 'jpenny@rotoloconsultants.com', 'wsims@rotoloconsultants.com', 'wmacmurdo@rotoloconsultants.com'],
    BR2: ['bmacmurdo@rotoloconsultants.com', 'gclark@rotoloconsultants.com'],
    BR3: ['jhaile@rotoloconsultants.com', 'jhaile@rotoloconsultants.com', 'wmacmurdo@rotoloconsultants.com'],
    BR4: ['wsims@rotoloconsultants.com', 'wmacmurdo@rotoloconsultants.com'],
    BR5: ['wsims@rotoloconsultants.com', 'wmacmurdo@rotoloconsultants.com'],
    BR6: ['wsims@rotoloconsultants.com', 'dross@rotoloconsultants.com', 'wmacmurdo@rotoloconsultants.com'],
    BR7: ['cmurphey@rotoloconsultants.com', 'dross@rotoloconsultants.com', 'nbotway@rotoloconsultants.com', 'wsims@rotoloconsultants.com', 'wmacmurdo@rotoloconsultants.com'],
    NLA1: ['csmith@rotoloconsultants.com', 'wmacmurdo@rotoloconsultants.com'],
    NLA2: ['csmith@rotoloconsultants.com', 'wmacmurdo@rotoloconsultants.com'],
    GP1: ['gporter@rotoloconsultants.com', 'shill@rotoloconsultants.com', 'twilliford@rotoloconsultants.com'],
    GP2: ['gporter@rotoloconsultants.com', 'shill@rotoloconsultants.com', 'twilliford@rotoloconsultants.com'],
    GP3: ['gporter@rotoloconsultants.com', 'shill@rotoloconsultants.com', 'twilliford@rotoloconsultants.com'],
    GP4: ['gporter@rotoloconsultants.com', 'shill@rotoloconsultants.com', 'twilliford@rotoloconsultants.com'],
    GP5: ['gporter@rotoloconsultants.com', 'shill@rotoloconsultants.com', 'twilliford@rotoloconsultants.com'],
    BAY1: ['gporter@rotoloconsultants.com', 'mkelley@rotoloconsultants.com', 'rmcclure@rotoloconsultants.com'],
    BAY2: ['gporter@rotoloconsultants.com', 'mkelley@rotoloconsultants.com', 'rmcclure@rotoloconsultants.com', 'tthompson@rotoloconsultants.com'],
    BAY3: ['gporter@rotoloconsultants.com', 'mkelley@rotoloconsultants.com', 'rmcclure@rotoloconsultants.com', 'tthompson@rotoloconsultants.com'],
    BAY4: ['mkelley@rotoloconsultants.com', 'rmcclure@rotoloconsultants.com', 'jacobs@rotoloconsultants.com', 'bwaddle@rotoloconsultants.com', 'cclark@rotoloconsultants.com', 'kgordon@rotoloconsultants.com'],
    BAY5: ['mkelley@rotoloconsultants.com', 'gporter@rotoloconsultants.com', 'bwaddle@rotoloconsultants.com', 'jdoyle@rotoloconsultants.com', 'kgordon@rotoloconsultants.com', 'rtaylor@rotoloconsultants.com', 'rmcclure@rotoloconsultants.com', 'shill@rotoloconsultants.com'],
    ALX: ['blinton@rotoloconsultants.com', 'dlamb@rotoloconsultants.com', 'dpritchett@rotoloconsultants.com', 'rmorrison@rotoloconsultants.com', 'jberry@rotoloconsultants.com'],
    BIR: ['blinton@rotoloconsultants.com', 'bstegall@rotoloconsultants.com', 'crockett@rotoloconsultants.com', 'dpritchett@rotoloconsultants.com', 'rmorrison@rotoloconsultants.com'],
    NAS: ['blinton@rotoloconsultants.com', 'bstegall@rotoloconsultants.com', 'dpritchett@rotoloconsultants.com', 'rmorrison@rotoloconsultants.com'],
    TUS: ['blinton@rotoloconsultants.com', 'bstegall@rotoloconsultants.com', 'dlamb@rotoloconsultants.com', 'crockett@rotoloconsultants.com', 'rmorrison@rotoloconsultants.com', 'dlamb@rotoloconsultants.com'],
    LAB: ['jdelafosse@rotoloconsultants.com', 'cbillingsley@rotoloconsultants.com', 'dwells@rotoloconsultants.com'],
    HOU1: ['dstanton@rotoloconsultants.com', 'lgravett@rotoloconsultants.com', 'jdelafosse@rotoloconsultants.com', 'echavez@rotoloconsultants.com'],
    HOU2: ['jdelafosse@rotoloconsultants.com', 'dstanton@rotoloconsultants.com'],
    HOU3: ['dstanton@rotoloconsultants.com', 'jdelafosse@rotoloconsultants.com'],
    ORL: ['edavis@rotoloconsultants.com', 'bsandritter@rotoloconsultants.com', 'jneuber@rotoloconsultants.com', 'edavis@rotoloconsultants.com'],
    JAX: ['blinton@rotoloconsultants.com', 'whardin@rotoloconsultants.com', 'tspence@rotoloconsultants.com', 'kcoulton@rotoloconsultants.com'],
    MEM1: ['blinton@rotoloconsultants.com', 'rflynn@rotoloconsultants.com', 'kcoulton@rotoloconsultants.com'],
    MEM2: ['blinton@rotoloconsultants.com', 'bfarmer@rotoloconsultants.com', 'kcoulton@rotoloconsultants.com'],
    MEM3: ['blinton@rotoloconsultants.com', 'mholstead@rotoloconsultants.com', 'kcoulton@rotoloconsultants.com'],
    JXV: ['rsmith@rotoloconsultants.com'],
    SOC: ['jfox@rotoloconsultants.com', 'twilliford@rotoloconsultants.com'],
    NIL: ['ejporter66@gmail.com'],
  };

  return marketEmailMap[normalized] || [];
};



    

  const fetchBase64Images = async (rawImageUrls = []) => {
  const storage = getStorage();
  const base64Images = [];

  for (const rawUrl of rawImageUrls.filter(Boolean)) {
    try {
      const match = rawUrl.match(/o\/(.+?)\?/);
      if (!match) continue;

      const path = decodeURIComponent(match[1]);
      const imageRef = ref(storage, path);

      // ✅ Get download URL and fetch the blob
      const downloadUrl = await getDownloadURL(imageRef);
      const response = await fetch(downloadUrl);
      const originalBlob = await response.blob();

      // ✅ Compress image using Compressor.js
      const compressedBlob = await new Promise((resolve, reject) => {
        new Compressor(originalBlob, {
          quality: 0.4,
          maxWidth: 1024,
          maxHeight: 1024,
          convertSize: 500000, // compress anything >500KB
          success: resolve,
          error: reject,
        });
      });

      // ✅ Convert to base64
      const base64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result); // includes data:image/jpeg;base64,...
        reader.readAsDataURL(compressedBlob);
      });

      base64Images.push(base64);
    } catch (err) {
      console.warn('⚠️ Failed to compress/convert image:', err);
    }
  }

  return base64Images;
};



  const sendEmail = async () => {
    try {
      setIsSending(true);
       setStatus('Processing images...');
    const imageUrls = selectedReport?.attachments?.imageURLs || [];
    const base64Images = await fetchBase64Images(imageUrls);

    // 2. Generate PDF with embedded images
    setStatus('Generating PDF...');
    const pdfBlob = await pdf(
     <IncidentReportPDF reportData={selectedReport} base64Images={base64Images} />


    ).toBlob();

    // 3. Convert PDF blob to base64 string
    const pdfBase64 = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.split(',')[1]);
      reader.readAsDataURL(pdfBlob);
    });

      setStatus('Sending email...');
      
      const market = selectedReport?.employee?.market;
      const managerEmails = getManagerEmailsByMarket(market);
      const allRecipients = Array.from(new Set(['safety@rotoloconsultants.com', ...(managerEmails || [])]));

      console.log('📧 Final recipients list:', allRecipients);

      const emailData = {
  to: allRecipients,
 

        subject: `Incident Report - ${selectedReport?.employee?.name || selectedReport?.submittedByName || 'Unnamed'}`,
        text: `An incident report has been submitted by ${selectedReport?.submittedByName || 'Unknown'} (${selectedReport?.createdBy || 'No email provided'}). Please see the attached PDF and photo documentation.`,
        html: `An incident report has been submitted by <strong>${selectedReport?.submittedByName || 'Unknown'}</strong> (${selectedReport?.createdBy || 'No email provided'}). Please see the attached PDF and photo documentation.`,

        from: 'serviceupdate@rotoloconsultants.com',
        attachments: [
          {
            content: pdfBase64,
            filename: 'incident_report.pdf',
            type: 'application/pdf',
            disposition: 'attachment',
          },
          ...base64Images.map((img, index) => ({
             content: img.split(',')[1],
             filename: `image_${index + 1}.jpg`,
             type: 'image/jpeg',
             disposition: 'attachment',
          }))

        ],
      };

      console.log('📤 Final emailData:', emailData);

      const response = await fetch('/api/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ emailData }),
      });

      if (response.ok) {
        setStatus('Email sent successfully!');
        setTimeout(() => navigate(getDashboardLink()), 1500); // Optional delay

      } else {
        throw new Error('Email send failed');
      }
    } catch (err) {
      console.error('Email sending error:', err);
      setError('Failed to send email. Please try again.');
    } finally {
      setIsSending(false);  
    }
  };

  useEffect(() => {
    if (selectedReport) {
      sendEmail();
    }
  }, [selectedReport]);


  return (
    <div className="custom-modal-overlay">
  <div className="custom-modal">
    <h2>Sending Incident Report</h2>
    <p>{status}</p>
    {error && <p style={{ color: 'red' }}>{error}</p>}
    <button className="send-button" onClick={sendEmail} disabled={isSending}>
       {isSending ? 'Sending...' : 'Send Incident Report'}
    </button>

  </div>
</div>

  );
};

export default IncidentEmailSender;
